import React from 'react';
import {useTranslation} from 'react-i18next';
import {Icon} from '@iconify/react';
import Label from '../../../../../incase-domain/components/label/Label';

export function EmptyTablePlaceholder(): JSX.Element | null {
    const {t} = useTranslation();

    return (
        <div className="c-genericTable__placeholderEmpty">
            <Icon className="c-genericTable__placeholderEmpty_icon" icon="solar:database-bold" />
            <Label className="c-genericTable__placeholderEmpty_label">{t('genericTable.nothingFound')}</Label>
        </div>
    );
}

export default EmptyTablePlaceholder;
